import { CustomLabel } from "@mindmemobile/mm-shared-global";
import { theme } from "@mindmemobile/mm-shared-global";
import styled from "styled-components";  

const { primary, text } = theme.palette;

export const SideBarContainer = styled.div`
  width: 130px;
  background-color: ${primary.light};
  padding: 45px 40px;
`;
export const SidebarSelectors = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 45px;
  position: relative;
  img {
    height: 45px;
    width: 45px;
    margin-bottom: 10px;
    &.item-details-icon {
      height: 50px;
      width: 50px;
    }
  }
  ${CustomLabel} {
    font-size: 18px;
    font-weight: 600;
    color: ${text.dark};
    white-space: nowrap;
    &.active {
      color: #1976d2;
    }
  }
  /* Add active class here and in HTML */
  &.active::after {
    position: absolute;
    top: 0px;
    left: unset;
    right: 0px;
    display: inline-block;
    content: "";
    transform: translate(55px, 27px);
    border-top: 17px solid transparent;
    border-bottom: 17px solid transparent;
    border-left: 17px solid ${primary.light};
  }
  &.after-pay-icon img {
    margin-left: 18px;
  }
`;
